import { WorkflowCaseStatus } from '@ebalance/proto/bffuser/v1/workflow_case_model_pb'

/**
 * ステータスフィルタのセグメント選択肢 (spec AC-05、workflow-delete-transition
 * design §4「ステータスフィルタ」)。
 */
export type WorkflowCaseStatusSegment = 'all' | 'notStarted' | 'inProgress'

/**
 * ステータスフィルタの segment + checkbox 2 個 (「完了を表示」「削除を表示」) から
 * List RPC へ送る `statuses` (repeated) を導出する純関数 (spec AC-05)。
 *
 * 基底集合はセグメントで決まる (all → [NOT_STARTED, IN_PROGRESS] / notStarted →
 * [NOT_STARTED] / inProgress → [IN_PROGRESS])。showComplete / showDeleted は
 * セグメント選択と独立に加算される。List RPC の `statuses` は空 = 全 status
 * (サーバー側フィルタなし) を意味するため、既定 (segment=all, 両 checkbox OFF) の
 * 絞り込み [NOT_STARTED, IN_PROGRESS] を成立させるには frontend が明示送信する
 * 必要がある (= API の驚き最小化。サーバー暗黙既定には頼らない)。
 */
export function deriveWorkflowCaseStatuses(
  segment: WorkflowCaseStatusSegment,
  showComplete: boolean,
  showDeleted: boolean,
): WorkflowCaseStatus[] {
  const base: WorkflowCaseStatus[] =
    segment === 'notStarted'
      ? [WorkflowCaseStatus.NOT_STARTED]
      : segment === 'inProgress'
        ? [WorkflowCaseStatus.IN_PROGRESS]
        : [WorkflowCaseStatus.NOT_STARTED, WorkflowCaseStatus.IN_PROGRESS]

  const statuses = [...base]
  if (showComplete) statuses.push(WorkflowCaseStatus.COMPLETE)
  if (showDeleted) statuses.push(WorkflowCaseStatus.DELETED)
  return statuses
}
